import type { SVGProps } from 'react';
const DawnFlagPT = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-PT_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-PT_svg__a)">
      <path fill="#FF2936" d="M0 0h22v16H0z" />
      <path fill="#128415" fillRule="evenodd" d="M0 16h8.38V0H0z" clipRule="evenodd" />
      <path
        stroke="#FAF94F"
        strokeWidth={1.333}
        d="M8.381 10.8c1.537 0 2.762-1.265 2.762-2.8S9.918 5.2 8.381 5.2 5.62 6.465 5.62 8s1.226 2.8 2.762 2.8Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M7.333 6.733c0-.184.15-.333.333-.333h1.429c.184 0 .333.15.333.333v1.82a1.048 1.048 0 0 1-2.095 0z"
        clipRule="evenodd"
      />
      <path
        fill="#1D50B5"
        fillRule="evenodd"
        d="M8.381 8.533c.29 0 .524-.772.524-1.066a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.235 1.066.524 1.066"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagPT;
